import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Grid, Field } from 'nallian-shared-ui/lib/components';
import { useTranslation } from 'react-i18next';
import { SelectFieldValueComponent } from 'nallian-shared-ui/lib/components/redux-form-semantic-ui';
import { FormModal } from 'nallian-shared-ui/lib/modules';
import { generateErrorsForRequiredFields } from '../../../app/lib/validationHelper';
import createFeatureSubscriptionService from '../../services/createFeatureSubscriptionService';
import organisationsService from '../../../organisations/services/organisationsService';

const FORM_NAME = 'createFeatureSubscription';
const REQUIRED_FIELDS = ['organisationId'];

const validate = values => {
  let errors = {};
  errors = generateErrorsForRequiredFields(REQUIRED_FIELDS, values, errors);
  return errors;
};

const CreateFeatureSubscriptionModal = ({
  open,
  returnRoute,
  appId,
  installationId,
  featureId,
  dispatchCreateFeatureSubscriptionPost,
  createFeatureSubscriptionFetch,
  onClose,
  getOrganisationsForSelectOptions,
  organisationsFetch,
  dispatchOrganisationsGet,
  resource,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (open) dispatchOrganisationsGet();
  }, [open, dispatchOrganisationsGet]);

  const organisations = getOrganisationsForSelectOptions();

  const handleSubmit = values => {
    dispatchCreateFeatureSubscriptionPost(
      appId,
      installationId,
      featureId,
      values,
      onClose,
      undefined,
      resource,
      t
    );
  };

  if (!open) return null;

  return (
    <FormModal
      closeIcon
      header={t('createFeatureSubscription')}
      dataLoading={false}
      submitProcessing={createFeatureSubscriptionFetch.pending}
      onSubmit={handleSubmit}
      onCancel={onClose}
      data={{}}
      t={t}
      validate={validate}
      form={FORM_NAME}
      cancelRoute={returnRoute}
      cancelButtonContent={t('cancel')}
      saveButtonIcon="save"
      saveButtonContent={t('create')}
    >
      <Grid>
        <Grid.Column mobile={16} tablet={16} computer={16}>
          <Field
            name="organisationId"
            valueComponent={SelectFieldValueComponent}
            loading={organisationsFetch.pending}
            label={t('organisation')}
            options={organisations}
            disabled={createFeatureSubscriptionFetch.pending || organisationsFetch.pending}
            search
            fluid
          />
        </Grid.Column>
      </Grid>
    </FormModal>
  );
};

CreateFeatureSubscriptionModal.propTypes = {
  open: PropTypes.bool.isRequired,
  returnRoute: PropTypes.string.isRequired,
  appId: PropTypes.string.isRequired,
  installationId: PropTypes.string.isRequired,
  featureId: PropTypes.string.isRequired,
  dispatchCreateFeatureSubscriptionPost: PropTypes.func.isRequired,
  createFeatureSubscriptionFetch: PropTypes.object.isRequired,
  getOrganisationsForSelectOptions: PropTypes.func.isRequired,
  organisationsFetch: PropTypes.object.isRequired,
  dispatchOrganisationsGet: PropTypes.func.isRequired,
  resource: PropTypes.string.isRequired,
  onClose: PropTypes.func,
};

CreateFeatureSubscriptionModal.defaultProps = { onClose: null };

export default compose(
  createFeatureSubscriptionService,
  organisationsService
)(CreateFeatureSubscriptionModal);
